export class FormatDecimalValue {
    public static getFormatted(value, symbol: boolean = true): string {
        const formatted = parseFloat(value)
            .toFixed(2)
            .replace(".", ",");
        return `${formatted}${symbol ? "€" : ""}`;
    }

    public static convertDecimal(decimalString: string | null | undefined): string | null | undefined {
        if (decimalString === null) {
            return null;
        }

        if (decimalString === undefined) {
            return undefined;
        }
        const integerString = decimalString.replace(/(\.0+|\.)$/, "");
        return integerString;
    }
}
